import React from 'react';

const About = () => (
  <div className="container">
    <h1>About This Project</h1>
    <p>Mario Database is een leerplatform om SQL te oefenen met echte projecten.</p>
  </div>
);

export default About;